import * as React from 'react';
import styled from 'styled-components';
import qs from 'qs';
import { ISuggestion } from './types';
import t from './locales';

const PillGroupContainer = styled.div`
  display: flex;
`;

const PillGroup = styled.a`
  display: flex;
  background-color: var(--blue100);
  border-radius: 1.5em;
  margin-right: 0.5em;
  cursor: pointer;
  &:hover {
    transition: all 0.3s ease;
    text-decoration: none;
    background-color: var(--blue200);
    > div {
      transition: all 0.3s ease;
      background-color: var(--blue200);
    }
  }
`;

const Pill = styled.div`
  width: 5em;
  height: 5em;
  border-radius: 1.5em;
  margin-right: 0.5em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--blue100);
  i {
    color: var(--blue600);
    font-size: 2em;
  }
  span {
    color: var(--gray900);
    font-size: 0.75em;
  }
  &:last-of-type {
    margin-right: 0;
  }
`;

// yado?: Array<'yado'>,
// item?: Array<'lift'|'rental'|'lesson'|'transport'>,
// insurance?: Array<'insurance'>,

interface IProps {
  navArray: {
    yado?: Array<string>,
    item?: Array<string>,
    insurance?: Array<string>,
  };
  q: ISuggestion|null;
}

const PillNavs: React.FC<IProps> = (props) => {
  const { navArray, q } = props;

  const contents = {
    yado: {
      icon: 'icon-hotel_solid',
      label: t.hotel(),
    },
    lift: {
      icon: 'icon-lift_solid',
      label: t.lift(),
    },
    rental: {
      icon: 'icon-rental_solid',
      label: t.rental(),
    },
    lesson: {
      icon: 'icon-lesson_solid',
      label: t.lesson(),
    },
    transport: {
      icon: 'icon-bus_solid',
      label: t.transport(),
    },
    insurance: {
      icon: 'icon-insurance_solid',
      label: t.insurance(),
    },
  }

  function renderPill(navs: string[], path: string) {
    return (
      <PillGroup href={path}>
        {navs.map((nav) => {
          const content = contents[nav];
          return (
            <Pill key={nav}>
              <i className={content.icon} />
              <span>{content.label}</span>
            </Pill>
          );
        })}
      </PillGroup>
    );
  }

  return (
    <PillGroupContainer>
      {navArray.yado && renderPill(navArray.yado, '/snow/stay')}
      {navArray.item && renderPill(navArray.item, `/snow/items?${qs.stringify({ q })}`)}
      {navArray.insurance && renderPill(navArray.insurance, '/snow/insurance/standard')}
    </PillGroupContainer>
  );
};

export default PillNavs;
